import { RouterOutput } from "@mindlercare/mindlerapi-client";
import { Typography } from "components/typography";
import { styled } from "styled-components";

interface SlotStatisticsProps {
  slots: RouterOutput["statistics"]["getAllSlotsByPsychologistId"]["slots"];
}

export const SlotStatistics = ({ slots }: SlotStatisticsProps): JSX.Element => {
  return (
    <SlotStatisticsWrapper>
      {/* eslint-disable-next-line i18next/no-literal-string */}
      <Typography variant="h3">By slot type</Typography>
      <SlotStat title="Booked" value={slots.statuses.BOOKED.total.toString()} />
      <SlotStat
        title="Not booked"
        value={slots.statuses.OPEN.total.toString()}
      />
      <SlotStat
        title="Cancelled"
        value={slots.statuses.CANCELED.total.toString()}
      />
      <SlotStat
        title="No show"
        value={slots.statuses.NO_SHOW.total.toString()}
      />
      <SlotStat
        title="No show all"
        value={slots.statuses.NO_SHOW_ALL.total.toString()}
      />
    </SlotStatisticsWrapper>
  );
};

export const CancelledSlotStatistics = ({
  slots,
}: SlotStatisticsProps): JSX.Element => {
  return (
    <SlotStatisticsWrapper>
      {/* eslint-disable-next-line i18next/no-literal-string */}
      <Typography variant="h3">By cancellation type</Typography>

      <SlotStat
        title="Patient"
        value={slots.statuses.CANCELED.byPat.toString()}
      />
      <SlotStat
        title="Psychologist"
        value={slots.statuses.CANCELED.byPsy.toString()}
      />
      <SlotStat
        title="Admin"
        value={slots.statuses.CANCELED.byAdmin.toString()}
      />
      <SlotStat
        title="Customer service"
        value={slots.statuses.CANCELED.byHqEmployee.toString()}
      />
    </SlotStatisticsWrapper>
  );
};

const SlotStat = ({ title, value }: { title: string; value: string }) => {
  return (
    <SlotStatWrapper>
      <Typography variant="body" color="GRAY_DARK">
        {title}
      </Typography>
      <Typography variant="body-bold">{value}</Typography>
    </SlotStatWrapper>
  );
};

const SlotStatisticsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.SPACING.SM};
`;

const SlotStatWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;
